<div class="share">
  <app-share-link></app-share-link>
  <app-share-download></app-share-download>
</div>



// WEBPACK FOOTER //
// ./src/app/rec/components/share/share.component.html